import styled from 'styled-components';

interface ReportSettingItemProps {
  hasSecondColumn?: boolean;
  hasSecondRow?: boolean;
}

const ReportSettingItem = styled.div<ReportSettingItemProps>`
  display: grid;

  grid-template-columns: ${(props): string =>
    props.hasSecondColumn ? '2.4rem 1fr 1fr' : '2.4rem 1fr'};
  grid-template-rows: ${(props): string =>
    props.hasSecondRow ? 'auto auto auto auto' : 'auto auto'};

  grid-auto-flow: column;

  grid-column-gap: ${(props): string => props.theme.spaces.lg};
  margin-top: ${(props): string => props.theme.spaces.xl};
  margin-right: ${(props): string => props.theme.spaces.xl};

  &:first-child {
    margin-top: 0;
  }

  > svg {
    grid-row: 1 / -1;
    margin-top: ${(props): string => props.theme.spaces.sm};
  }

  ${(props): string =>
    props.hasSecondRow
      ? `> span:nth-of-type(4n + 3) {
          padding-top: ${props.theme.spaces.lg};
        };`
      : ''}
`;

export { ReportSettingItem };
